import { createAction } from 'redux-actions';
import { createFormAction } from 'redux-form-saga';
import { createRequestActions } from '../utils';
import * as orderImportTypes from './orderImportTypes';

export const initializePolling = createRequestActions(orderImportTypes.INITIALIZE_POLLING);
export const poll = createRequestActions(orderImportTypes.POLL);
export const goToHangfire = createRequestActions(orderImportTypes.GOTOHANGFIRE);
export const listOrderImports = createRequestActions(orderImportTypes.ORDER_IMPORT_LIST);
